import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import '@fontsource/inter/400.css';
import '@fontsource/inter/500.css';
import '@fontsource/inter/600.css';
import '@fontsource/inter/700.css';
import '@fontsource/inter/800.css';
// interface icons (components/ui/icons.tsx): regular, plus bold/solid for emphasis and filled glyphs
import '@flaticon/flaticon-uicons/css/regular/rounded.css';
import '@flaticon/flaticon-uicons/css/bold/rounded.css';
import '@flaticon/flaticon-uicons/css/solid/rounded.css';
import './styles/tokens.css';
import './styles/base.css';
import './styles/components.css';
import './styles/shell.css';
import './styles/fields.css';
import './styles/views.css';
import './styles/task.css';
import './styles/pages.css';
import { App } from './App';

// desktop app: the top bar doubles as the window title bar (shell.css .desktop-darwin / .desktop-win32)
const platform = window.atriumDesktop?.platform;
if (platform) document.documentElement.classList.add('desktop', `desktop-${platform}`);

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
